export const socialsData = {
    youtube: 'https://www.youtube.com/channel/UCqiv_AI9r1VRMkWA4MFh57g',
    // reddit: 'https://nikewear.netlify.app/',
    github: 'https://github.com/Salman-Pixel',
    facebook: 'https://www.facebook.com/salupixel',
    linkedIn: 'https://www.linkedin.com/in/salman-pixel/',
    instagram: 'https://www.instagram.com/salmnkrim',
    // codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/ctrlSalmany',
    blogger: 'https://thisisindexed.com/',
    // medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/15504574/salman-karim',
    gitlab: 'https://git.discretelogix.com/salman-pixel',
}